var  elementsForm,contLogin;
$(function() {
    $('.buyProduct').click(function () {
        var id = this.id;
        $('#selectProduct').submit();
    });

    $('#selectProduct').on('submit', function (e) {
        e.preventDefault();

        elementsForm = [
            "idProduct",
            "cantproduct",
            "colorId"
        ];

        contLogin = validationForm(elementsForm, contLogin = 1);

        if (contLogin == 0) {
            swal({
                text: "Debes seleccionar un color",
                icon: imageURL,
                button: "OK!",
            });
            return false;
        }

        var data = $(this).serialize();

        $.ajax({
            url: https + 'buyProduct',
            method: "POST",
            data: data,
            success: function (data) {
                if ($.trim(data) > 0) {
                    $('#modalAddCar').modal('open');
                    $('#numberCarShop').html(data);
                    $('#numberCarShopMobile').html(data);
                } else {
                    swal({
                        text: "" + data,
                        icon: imageURL,
                        button: "OK!",
                    });
                }
            }
        });
    });

    function validationForm(elementsForm, contLogin) {
        for (var i = 0; i < elementsForm.length; i++) {

            $('#' + elementsForm[i]).removeClass('error');

            if ($.trim($("#" + elementsForm[i]).val()) == "") {
                contLogin = 0;
                $('#' + elementsForm[i]).addClass('error');
            }

        }

        return contLogin;
    }

    $('.sectionDescriptionProduct .plus .left').click(function () {
        if($('#cantproduct').val() <= 0){
            $('#sectionDescriptionProduct').val(1);
            $('.sectionDescriptionProduct .plus span').html(1);
        }else{
            $('.sectionDescriptionProduct .plus span').html(parseInt($('#cantproduct').val())-1);
            $('#cantproduct').val(parseInt($('#cantproduct').val())-1);
        }
    });

    $('.sectionDescriptionProduct .plus .right').click(function () {
        $('.sectionDescriptionProduct .plus span').html(parseInt($('#cantproduct').val())+1);
        $('#cantproduct').val(parseInt($('#cantproduct').val())+1);
    });

});